export default __webpack_public_path__ + "static/media/mobile-menu.2a5fc75c.svg";